/** Etiquetas para campos del formulario de solicitud (portal público y gestión). */
export const PROYECTOS_SOLICITUD_CAMPO_LABELS: Record<string, string> = {
  codigo: "Código",
  nombre: "Nombre del proyecto",
  tipo_proyecto: "Tipo de proyecto",
  nivel_tension: "Nivel de tensión",
  fecha_estimada_operacion: "Fecha estimada de operación",
  numero_usuarios: "Número de usuarios",
  carga_total_solicitada_kva: "Carga total solicitada (kVA)",
  tipo_subestacion: "Tipo de subestación",
  nodo_referencia: "Nodo de referencia",
  nombre_solicitante: "Nombre del solicitante",
  tipo_documento: "Tipo de documento",
  documento_solicitante: "Documento",
  tipo_persona: "Tipo de persona",
  tipo_persona_juridica: "Tipo de persona jurídica",
  correo_notificacion: "Correo",
  telefono_solicitante: "Celular",
  telefono_fijo: "Teléfono fijo",
  predio_departamento: "Departamento del predio",
  predio_municipio: "Municipio del predio",
  predio_comuna: "Comuna del predio",
  direccion_predio: "Dirección del predio",
  observaciones: "Observaciones",
  responsable_emcali: "Responsable EMCALI",
  fecha_radicado: "Fecha de solicitud",
};
